import { render, staticRenderFns } from "./group-3.vue?vue&type=template&id=f521db9c&scoped=true&"
import script from "./group-3.vue?vue&type=script&lang=js&"
export * from "./group-3.vue?vue&type=script&lang=js&"
import style0 from "./group-3.vue?vue&type=style&index=0&id=f521db9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f521db9c",
  null
  
)

export default component.exports